import cn from 'classnames'
import {
  changeSaleType,
  selectActualsFromSellTo,
  selectSalesTypeOptions,
  selectSaleType,
} from 'legacy/lut/features/partner360/configuration'
import { ISalesTypeItem } from 'legacy/lut/features/partner360/configuration/models/iSalesTypeItem'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { FC, useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

import { RowButtons } from '../rowButtons/RowButtons'

import { ISellTypeButtonsProps } from './models/sellTypeButtonsProps'

import styles from './SellTypeButtons.module.scss'

export const SellTypeButtons: FC<ISellTypeButtonsProps> = ({ actualsType }) => {
  /** -------------------- Hooks ----------------------- */

  const dispatch = useAppDispatch()

  /** -------------------- Selectors ----------------------- */

  const actualsFromSellTo = useSelector(selectActualsFromSellTo)
  const saleType = useSelector(selectSaleType)
  const salesTypes = useSelector(selectSalesTypeOptions)

  /** -------------------- Variables ----------------------- */

  const selectedValue = useMemo(() => {
    if (!saleType) {
      return salesTypes[0]
    }

    return saleType
  }, [salesTypes, saleType])

  /** -------------------- Methods ----------------------- */

  const isActualsTypeSuffix = useMemo(
    () =>
      !!actualsFromSellTo &&
      !!actualsType &&
      (actualsType === ActualsValueTypes.UTNet || actualsType === ActualsValueTypes.TNet),
    [actualsFromSellTo, actualsType]
  )

  const getTranslationKey = useCallback(
    (it: ISalesTypeItem) => {
      if (isActualsTypeSuffix) {
        return `${it.salesType}-${actualsType!.toLowerCase()}`
      }

      return it.salesType
    },
    [isActualsTypeSuffix, actualsType]
  )

  const getTooltipTranslationKey = useCallback(
    (it: ISalesTypeItem) => {
      if (isActualsTypeSuffix) {
        return `${it.salesTypeComment}-${actualsType!.toLowerCase()}`
      }

      return it.salesTypeComment
    },
    [isActualsTypeSuffix, actualsType]
  )

  /** -------------------- User actions handlers ----------------------- */

  const handleOptionClick = useCallback(
    (newValue: ISalesTypeItem) => {
      dispatch(changeSaleType(newValue))
    },
    [dispatch]
  )

  /** -------------------- Render ----------------------- */

  return (
    <RowButtons
      buttonClassName={cn(styles.sellTypeButton)}
      value={selectedValue}
      options={salesTypes}
      generateTranslationKey={getTranslationKey}
      generateTooltipTranslationKey={getTooltipTranslationKey}
      onOptionClick={handleOptionClick}
    />
  )
}
